import {
  Alert,
  Info,
  Loading,
  StringUtils,
  ValidationUtils,
  Wizard,
  formatUtils
} from '@elotech/components';
import { PessoasQuickView } from 'itbi-common/components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  CadastroGeralService,
  CadastroRuralService,
  DebitoService,
  DeclaracaoService,
  ImobiliarioService,
  ParametroGeralService,
  ParametroService,
  ProprietarioService,
  UploadService,
  UserService,
  withService
} from '../../service';
import { InscricaoCadastralUtils } from '../../utils';
import CalculoDeclaracaoitbiUtils from '../../utils/CalculoDeclaracaoitbiUtils';
import { getDeferirSuccessMessage } from '../../utils/DeclaracaoItbiUtils';
import {
  validaPercentualDosProprietarios,
  validaPercentualIsencaoMaiorCem,
  validaPercentualIsencaoMenorIgualZero,
  validaValorFinanciadoAvaliacao,
  validaValorIsencao,
  validaValorIsencaoMaiorItbi,
  validaValorTransacaoAvaliacao
} from '../../utils/DeclaracaoItbiUtils';
import DebitosEmAbertoTable from './DebitosEmAbertoTable';
import EnglobadosList from './englobamento/EnglobadosList';
import Identificacao from './identificacao/Identificacao';
import Imovel from './imovel/Imovel';
import ItbiMaisFacilModal, {
  showItbiMaisFacilSuccess,
  showTramitacaoAutomaticaSuccess
} from './ItbiMaisFacilModal';
import Resumo from './Resumo';

const { validateCpfCnpj } = ValidationUtils;

const moduloTributos = '05';

const CAMPOS_SINCRONIZADOS = {
  valorTransacao: 'valorTransacaoAvaliacao',
  valorTransacaoAvaliacao: 'valorTransacao',
  valorFinanciado: 'valorFinanciadoAvaliacao',
  valorFinanciadoAvaliacao: 'valorFinanciado'
};

const prepareDadosImoveisState = (parametroItbi, tipoItbi, state) => ({
  tipoItbi: {
    ...tipoItbi,
    value: tipoItbi.value || tipoItbi.id,
    parametroItbi: parametroItbi
  },
  aliquotaTransacao: parametroItbi?.aliquotaNormal || 0,
  aliquotaFinanciado: parametroItbi?.aliquotaFinanciado || 0,
  utilizaAliquotaDiferenciadaTipoNormal:
    parametroItbi?.utilizaAliquotaDiferenciadaTipoNormal || false,
  tipoAliquotaDiferenciadaNormal:
    parametroItbi?.tipoAliquotaDiferenciadaNormal || 'FAIXA',
  aliquotasNormal: parametroItbi?.aliquotasNormal || [],
  utilizaAliquotaDiferenciadaTipoFinanciado:
    parametroItbi?.utilizaAliquotaDiferenciadaTipoFinanciado || false,
  tipoAliquotaDiferenciadaFinanciado:
    parametroItbi?.tipoAliquotaDiferenciadaFinanciado || 'FAIXA',
  aliquotasFinanciado: parametroItbi?.aliquotasFinanciado || [],
  utilizaAliquotaDiferenciadaTipoFinanciadoAVista:
    parametroItbi?.utilizaAliquotaDiferenciadaTipoFinanciadoAVista || false,
  tipoAliquotaDiferenciadaFinanciadoAVista:
    parametroItbi?.tipoAliquotaDiferenciadaFinanciadoAVista || 'FAIXA',
  aliquotasFinanciadoAVista: parametroItbi?.aliquotasFinanciadoAVista || [],
  valorTransacaoAvaliacao:
    state.id && tipoItbi.value === state.tipoItbiOriginal
      ? state.valoresOriginais?.valorTransacaoAvaliacao || 0
      : state.dadosImoveis.valorTransacaoAvaliacao || 0,
  valorTransacaoItbi:
    state.id && tipoItbi.value === state.tipoItbiOriginal
      ? state.valoresOriginais?.valorTransacaoItbi || 0
      : state.dadosImoveis.valorTransacaoItbi || 0,
  valorFinanciadoItbi:
    state.id && tipoItbi.value === state.tipoItbiOriginal
      ? state.valoresOriginais?.valorFinanciadoItbi || 0
      : state.dadosImoveis.valorFinanciadoItbi || 0,
  valorFinanciado:
    tipoItbi && (tipoItbi.financiado || tipoItbi.anuencia)
      ? state.dadosImoveis.valorFinanciado
      : undefined,
  valorFinanciadoAvaliacao:
    tipoItbi && (tipoItbi.financiado || tipoItbi.anuencia)
      ? state.dadosImoveis.valorFinanciadoAvaliacao
      : undefined,
  error: {
    ...state.dadosImoveis.error,
    tipoItbi: false,
    loadDocumentos: false
  }
});

const valoresAvaliacao = {
  valorTransacaoAvaliacao: {
    aliquota: 'aliquotaTransacao',
    campo: 'valorTransacaoItbi'
  },
  valorFinanciadoAvaliacao: {
    aliquota: 'aliquotaFinanciado',
    campo: 'valorFinanciadoItbi'
  },
  valorIsencao: {
    aliquota: 'aliquotaTransacao',
    campo: 'valorIsencao'
  },
  percentualIsencao: {
    aliquota: 'aliquotaTransacao',
    campo: 'percentualIsencao'
  }
};

const isValidEmail = email => {
  if (!email) {
    return true;
  }

  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);
};

const errorMessages = {
  cadastro: 'Cadastro inválido!',
  inscricaoCadastral: 'Inscrição cadastral inválida!',
  numeroEnderecoLength: 'Número deve ter no máximo 10 caracteres',
  cadastroRural: 'Cadastro rural inválido!',
  enderecoDescrito:
    'Endereço é obrigatório para a criação automática do cadastro rural!',
  tipoItbi: 'Tipo ITBI é obrigatório!',
  valorTransacao: 'Valor é obrigatório!',
  valorFinanciado: 'Valor é obrigatório!',
  loadDocumentos: 'Falha ao carregar os documentos!',
  compradores: 'Comprador é obrigatório!',
  compradorIncompleto: 'Comprador possui campo obrigatório não preenchido!',
  vendedores: 'Vendedor é obrigatório!',
  anuentes: 'Anuente é obrigatório!',
  percentualCompraVenda: 'Percentual compra deve ser igual ao de venda!',
  requerenteComprador: 'Requerente deve ser comprador!',
  requerenteCompradorVendedor:
    'Requerente deve ser comprador, vendedor ou anuente!',
  rascunho: 'Não foi possível salvar o rascunho!',
  documentoObrigatorio: 'O documento é obrigatório',
  documentoTamanho: 'Arquivo é maior que 50 MB',
  requerente: {
    id: 'Requerente é obrigatório',
    cpfCnpj: 'O CPF/CNPJ está inválido.',
    cpfCnpjCadastrado: 'O CPF/CNPJ já foi adicionado na lista',
    nome: 'O nome é obrigatório.',
    nomeLength: 'Máximo 150 caracteres.',
    email: 'O email é obrigatório',
    emailInvalid: 'O e-mail está inválido.'
  },
  cadastroInadimplente: 'Cadastro está irregular, contatar prefeitura',
  documentoProcuracaoRequerente:
    'Documento de Procuração de Requerente necessário!',
  proprietarios: 'É necessário informar ao menos um novo proprietário.',
  percentualProprietarios:
    'Soma do percentual de posse dos proprietários deve ser igual a 100%.',
  vinculoProprietarios: 'Existe proprietário sem vínculo informado.',
  matricula: 'Matrícula inválida!'
};

class DeclaracaoItbiForm extends Component {
  static propTypes = {
    imobiliarioService: PropTypes.object.isRequired,
    parametroGeralService: PropTypes.object.isRequired,
    parametroService: PropTypes.object.isRequired,
    declaracaoService: PropTypes.object.isRequired,
    uploadService: PropTypes.object.isRequired,
    proprietarioService: PropTypes.object.isRequired,
    cadastroRuralService: PropTypes.object.isRequired,
    cadastroGeralService: PropTypes.object.isRequired,
    debitoService: PropTypes.object.isRequired,
    userService: PropTypes.object.isRequired,
    showNotification: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    listRequerentes: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object,
    isServidor: PropTypes.bool,
    permiteItbiRural: PropTypes.bool,
    onSubmit: PropTypes.func
  };

  imobiliarioEmpty = {
    cadastro: '',
    inscricaoCadastral: '',
    zona: '',
    quadra: '',
    lote: '',
    areaTerreno: '',
    areaConstruida: '',
    cep: '',
    endereco: '',
    cidade: '',
    numero: '',
    estado: '',
    complemento: '',
    condominio: '',
    descricaoCondominio: ''
  };

  chaveDebitosConsultada = null;

  parametrosPromise = null;

  state = {
    camposLocalizacao: [],
    step1: { valid: true, errorMessage: '' },
    step2: { valid: true, errorMessage: '' },
    step3: { valid: true, errorMessage: '' },
    loadingCep: false,
    loadingRascunhoEditar: false,
    pessoaQuickView: undefined,
    id: undefined,
    parametrosItbiError: null,
    itbiMaisFacil: {
      visible: false,
      dados: null,
      isFinanciado: false,
      aceitou: null
    },
    dadosImoveis: {
      listTipoItbi: [],
      tipoItbi: {
        label: 'Selecione...',
        anuencia: false,
        financiado: false,
        permiteTotalmenteFinanciado: false
      },
      situacaoItbi: { descricao: 'Rascunho', name: 'RASCUNHO' },
      valorTransacao: 0,
      valorFinanciado: 0,
      valorTransacaoAvaliacao: 0,
      valorTransacaoItbi: 0,
      valorFinanciadoItbi: 0,
      valorItbiRetificado: 0,
      aliquotaTransacao: 0,
      aliquotaFinanciado: 0,
      utilizaAliquotaDiferenciadaTipoNormal: false,
      tipoAliquotaDiferenciadaNormal: 'FAIXA',
      aliquotasNormal: [],
      utilizaAliquotaDiferenciadaTipoFinanciado: false,
      tipoAliquotaDiferenciadaFinanciado: 'FAIXA',
      aliquotasFinanciado: [],
      utilizaAliquotaDiferenciadaTipoFinanciadoAVista: false,
      tipoAliquotaDiferenciadaFinanciadoAVista: 'FAIXA',
      aliquotasFinanciadoAVista: [],
      cadastroImobiliario: this.imobiliarioEmpty,
      cadastroImobiliarioLoading: false,
      englobados: [],
      cadastroPaiEnglobamento: undefined,
      cadastroSelecionadoEnglobamento: undefined,
      temValorReferenciaItbiMaisFacil: false,
      cadastroRural: {},
      cadastroRuralLoading: false,
      imovelNotFoundByCadastro: false,
      imovelNotFoundByInscricaoCadastral: false,
      documentos: [],
      observacaoCidadao: '',
      observacaoServidor: '',
      tipoImovel: 'URBANO',
      requerente: {
        id: undefined,
        tipoPessoa: 'FISICA',
        cpfCnpj: '',
        nome: '',
        email: '',
        telefone: ''
      },
      error: {
        tipoItbi: false,
        loadDocumentos: false,
        valorTransacao: false,
        valorFinanciado: false,
        cadastro: false,
        inscricaoCadastral: false,
        rascunho: false,
        documentos: false,
        requerente: {},
        cadastroInadimplente: false
      }
    },
    dadosIdentificacao: {
      compradores: [],
      vendedores: [],
      anuentes: [],
      proprietarios: [],
      error: {
        compradorIncompleto: false,
        compradores: false,
        vendedores: false,
        anuentes: false,
        percentualCompraVenda: false,
        requerenteComprador: false,
        proprietarios: false,
        percentualProprietarios: false,
        vinculoProprietarios: false
      }
    },
    vinculos: [],
    parametros: undefined,
    valorRecursoProprio: false,
    loadingRequerente: false,
    isCadastroInadimplente: false,
    loadingInadimplencia: false,
    debitosEmAberto: undefined,
    avisoDebitosVisible: false,
    avisoDebitosExpandido: false,
    loadingDebitos: false
  };

  convertProprietariosToVendedores = proprietarios => {
    if (!proprietarios) {
      return null;
    }
    return proprietarios.map(proprietario => ({
      vinculo: proprietario?.vinculo,
      nome: proprietario?.nome,
      percentual: proprietario?.percentual,
      percentualVenda: 0,
      principal: proprietario?.principal,
      cpfCnpj: proprietario?.cpfCnpj,
      tipoPessoa: proprietario?.tipoPessoa,
      cep: proprietario.endereco?.cep,
      uf: proprietario.endereco?.uf,
      numero: proprietario.endereco?.numero,
      complemento: proprietario.endereco?.complemento,
      logradouroAise: proprietario.endereco?.logradouroAise,
      tipoLogradouroAise: proprietario.endereco?.tipoLogradouroAise,
      bairroAise: proprietario.endereco?.bairroAise,
      cidadeAise: proprietario.endereco?.cidadeAise,
      ibge: proprietario.endereco?.ibge,
      logradouro: proprietario.endereco?.logradouro,
      cidade: proprietario.endereco?.cidade,
      bairro: proprietario.endereco?.bairro
    }));
  };

  componentDidMount = () => {
    this.carregarCamposLocalizacao();

    const {
      match: { params },
      location,
      parametroGeralService,
      parametroService,
      proprietarioService,
      isServidor,
      permiteItbiRural
    } = this.props;

    if (params.id) {
      this.loadRascunho(params.id);
    }

    if (isServidor && location?.search) {
      const searchParams = Object.fromEntries(
        new URLSearchParams(location.search)
      );
      const tipoImovelRural = searchParams.tipoImovel === 'RURAL';
      const cadastro = searchParams.cadastro;
      this.setState(
        prevState => {
          return {
            dadosImoveis: {
              ...prevState.dadosImoveis,
              requerente: {
                nome: decodeURI(searchParams.nome ?? ''),
                cpfCnpj: searchParams.cpfCnpj,
                tipoPessoa:
                  searchParams.cpfCnpj?.length > 11 ? 'JURIDICA' : 'FISICA'
              },
              tipoImovel: permiteItbiRural ? searchParams.tipoImovel : 'URBANO',
              cadastroImobiliario: !tipoImovelRural
                ? {
                    cadastro: cadastro
                  }
                : prevState.dadosImoveis.cadastroImobiliario,
              cadastroRural: tipoImovelRural
                ? { cadastro: cadastro }
                : prevState.cadastroRural
            }
          };
        },
        () =>
          tipoImovelRural
            ? this.searchCadastroRural('cadastro', cadastro)
            : this.onSearchCadastroImobiliario('cadastro', cadastro)
      );
      this.props.history.replace('/declaracoes-itbi/novo');
    }

    parametroService
      .loadTiposItbi(isServidor)
      .then(response => {
        if (response.data) {
          this.setState(
            this.newStateDadosImoveis({
              listTipoItbi: this.mountlistTipoItbi(response.data)
            })
          );
        }
      })
      .catch(error => {
        Alert.error(
          {
            title: 'Erro ao carregar dados dos imóveis.'
          },
          error
        );
      });

    this.parametrosPromise = parametroService
      .loadAllParametros()
      .then(response => {
        this.setState({
          parametros: {
            ...response.data,
            permiteEditarProprietario:
              response.data?.permiteEditarProprietario ?? false,
            permiteDeletarProprietario:
              response.data?.permiteDeletarProprietario ?? false
          }
        });
      })
      .catch(error => {
        Alert.error(
          {
            title: 'Erro ao carregar os parâmetros.'
          },
          error
        );
      });

    proprietarioService
      .loadVinculos()
      .then(response => {
        if (response.data) {
          this.setState({ vinculos: response.data });
        }
      })
      .catch(error => {
        Alert.error(
          {
            title: 'Erro ao carregar vínculos.'
          },
          error
        );
      });

    parametroGeralService
      .findOne(moduloTributos, 'DESCVALORRECURSOPROPRIOITBI')
      .then(response => {
        if (response.data.valor === 'S') {
          this.setState({ valorRecursoProprio: true });
        }
      });
  };

  getDadosDeclaracao = () => {
    const { id, dadosImoveis, dadosIdentificacao, parametros } = this.state;
    const {
      tipoItbi,
      cadastroImobiliario,
      cadastroRural,
      tipoImovel,
      valorTransacaoItbi,
      valorItbiRetificado,
      retificadora
    } = dadosImoveis;

    let valorTransacaoItbiFinal = valorTransacaoItbi;
    if (
      parametros?.utilizaFluxoAutonomiaCidadao &&
      retificadora &&
      valorItbiRetificado > 0
    ) {
      valorTransacaoItbiFinal = valorItbiRetificado;
    }

    return {
      id,
      tipoItbi: tipoItbi,
      cadastroImobiliario:
        tipoImovel === 'URBANO'
          ? {
              id: cadastroImobiliario.id
            }
          : undefined,
      valorTransacao: dadosImoveis.valorTransacao,
      valorFinanciado: dadosImoveis.valorFinanciado || 0,
      valorTransacaoAvaliacao: dadosImoveis.valorTransacaoAvaliacao,
      valorFinanciadoAvaliacao: dadosImoveis.valorFinanciadoAvaliacao,
      aliquotaTransacao: dadosImoveis.aliquotaTransacao,
      aliquotaFinanciado: dadosImoveis.aliquotaFinanciado,
      valorTransacaoItbi: valorTransacaoItbiFinal,
      valorFinanciadoItbi: dadosImoveis.valorFinanciadoItbi,

      observacaoCidadao: dadosImoveis.observacaoCidadao,
      observacaoServidor: dadosImoveis.observacaoServidor,
      compradores: dadosIdentificacao.compradores,
      vendedores: dadosIdentificacao.vendedores,
      anuentes: dadosIdentificacao.anuentes,
      proprietarios: dadosIdentificacao.proprietarios,
      requerente: {
        id: dadosImoveis.requerente.id
      },
      requerenteTipoPessoa: dadosImoveis.requerente.tipoPessoa,
      requerenteCpfCnpj: dadosImoveis.requerente.cpfCnpj,
      requerenteNome: dadosImoveis.requerente.nome,
      requerenteEmail: dadosImoveis.requerente.email,
      requerenteTelefone: dadosImoveis.requerente.telefone,
      origemServidor: this.props.isServidor,
      tipoImovel: dadosImoveis.tipoImovel,
      valorOriginal: dadosImoveis.valorOriginal,
      retificadora: dadosImoveis.retificadora,
      cadastroRural: tipoImovel === 'RURAL' ? { ...cadastroRural } : undefined
    };
  };

  finalizar = () => {
    if (
      !this.onValidateDadosImoveis(this.state).valid ||
      !this.onValidateDadosIdentificacao(this.state).valid ||
      (this.state.isCadastroInadimplente &&
        this.state.parametros.bloqueiaItbiCadInadimplente)
    ) {
      return;
    }

    const {
      declaracaoService,
      showNotification,
      history,
      onSubmit
    } = this.props;

    const declaracao = this.getDadosDeclaracao();

    if (
      this.props.isServidor &&
      this.state.situacaoItbi?.name === 'ANALISANDO'
    ) {
      this.finalizarEdicaoEmAnalise(declaracao);
      return;
    }

    this.setStateSubmitting('step3', true);

    if (this.state.itbiMaisFacil.aceitou === true) {
      this.confirmarMaisFacilFinal(declaracao);
      return;
    }

    this.finalizarFluxoNormal(declaracao);
  };

  finalizarEdicaoEmAnalise = declaracao => {
    const { showNotification, history, onSubmit } = this.props;

    showNotification({
      level: 'success',
      message: 'Declaração atualizada com sucesso'
    });

    if (onSubmit) {
      return onSubmit({
        id: declaracao.id,
        situacaoItbi: this.state.situacaoItbi
      });
    }

    history.replace(`/declaracoes-itbi/${declaracao.id}`);
  };

  onAcceptItbiMaisFacil = () => {
    this.setState(state => ({
      itbiMaisFacil: { ...state.itbiMaisFacil, visible: false, aceitou: true }
    }));
  };

  onDeclineItbiMaisFacil = () => {
    this.setState(state => ({
      itbiMaisFacil: { ...state.itbiMaisFacil, visible: false, aceitou: false }
    }));
  };

  onCloseItbiMaisFacil = () => {
    this.setState(state => ({
      itbiMaisFacil: { ...state.itbiMaisFacil, visible: false, aceitou: false }
    }));
  };

  confirmarMaisFacilFinal = declaracao => {
    const { declaracaoService, showNotification, history } = this.props;

    const save = declaracao.id
      ? declaracaoService.updateRascunho
      : declaracaoService.salvarRascunho;

    showNotification({
      level: 'success',
      message: 'Processando ITBI Mais Fácil. Aguarde...'
    });

    save(declaracao)
      .then(() => declaracaoService.confirmarItbiMaisFacil(declaracao.id))
      .then(async responseConfirmar => {
        this.setStateSubmitting('step3', false);

        try {
          await showItbiMaisFacilSuccess(responseConfirmar.data?.boleto);
        } catch (alertError) {}

        history.replace(`/declaracoes-itbi/${declaracao.id}/resumo`, {
          novo: true
        });
      })
      .catch(error => {
        this.setStateSubmitting('step3', false);
        Alert.error({ title: 'Falha ao processar ITBI Mais Fácil' }, error);
      });
  };

  finalizarFluxoNormal = declaracao => {
    const {
      declaracaoService,
      showNotification,
      history,
      onSubmit
    } = this.props;

    if (this.state.parametros?.utilizaFluxoAutonomiaCidadao) {
      showNotification({
        level: 'success',
        message: 'Iniciando o processo de análise e geração do ITBI'
      });
    }

    declaracaoService
      .salvarDeclaracao(declaracao)
      .then(async response => {
        this.setStateSubmitting('step3', false);

        if (response.data?.tipoItbi?.utilizaTramitacaoAutomatica) {
          this.setStateSubmitting('step3', true);
          try {
            const resultado = await declaracaoService.confirmarTramitacaoAutomatica(
              response.data.id
            );
            this.setStateSubmitting('step3', false);
            await showTramitacaoAutomaticaSuccess(resultado.data?.boleto);
          } catch (error) {
            this.setStateSubmitting('step3', false);
            await Alert.error(
              {
                title: 'Não foi possível tramitar automaticamente',
                text:
                  'A declaração foi salva com sucesso, porém a tramitação automática falhou.'
              },
              error
            );
          }

          history.replace(`/declaracoes-itbi/${response.data.id}/resumo`, {
            novo: true
          });
          return;
        }

        showNotification({
          level: 'success',
          message: 'Declaração gerada com sucesso'
        });

        if (onSubmit) {
          return onSubmit(response.data);
        }

        if (this.state.parametros?.utilizaFluxoAutonomiaCidadao) {
          if (!this.onValidateValoresTransferencia(declaracao)) {
            return;
          }

          this.validacoesPreDeferimento()
            .then(() => {
              this.setStateSubmitting('step3', true);

              this.deferir(declaracao)
                .then(responseData => {
                  this.setStateSubmitting('step3', false);
                })
                .catch(errorMessage => {
                  this.setStateSubmitting('step3', false);
                  Alert.warning({
                    title: 'Problemas ao deferir declaração',
                    text: errorMessage
                  });
                });
            })
            .catch(errorMessage => {
              this.setStateSubmitting('step3', false);
              Alert.warning({
                title: 'Problemas ao deferir declaração',
                text: errorMessage
              });
            });
        } else {
          history.replace(`/declaracoes-itbi/${response.data.id}/resumo`, {
            novo: true
          });
        }
      })
      .catch(error => {
        this.setStateSubmitting('step3', false);
        Alert.error({ title: 'Não foi possível salvar o rascunho' }, error);
      });
  };

  async validacoesPreDeferimento() {
    return Promise.all([this.validaPercentualDosProprietarios()]);
  }

  validaPercentualDosProprietarios() {
    const { dadosIdentificacao } = this.state;
    return validaPercentualDosProprietarios(dadosIdentificacao.proprietarios);
  }

  onValidateValoresTransferencia = declaracaoItbi => {
    const errors = {
      valorTransacaoAvaliacao: this.errorValidators.valorTransacaoAvaliacao(
        declaracaoItbi
      ),
      valorFinanciadoAvaliacao: this.errorValidators.valorFinanciadoAvaliacao(
        declaracaoItbi
      ),
      valorIsencao: this.errorValidators.valorIsencao(declaracaoItbi),
      valorIsencaoMaiorItbi: this.errorValidators.valorIsencaoMaiorItbi(
        declaracaoItbi
      ),
      percentualIsencaoMaiorCem: this.errorValidators.percentualIsencaoMaiorCem(
        declaracaoItbi
      ),
      percentualIsencaoMenorIgualZero: this.errorValidators.percentualIsencaoMenorIgualZero(
        declaracaoItbi
      )
    };

    const valid = !Object.values(errors).some(Boolean);
    if (!valid) {
      const error = Object.keys(errors)
        .filter(key => errors[key])
        .slice(0);
      const errorMessage = errorMessages[error];
      this.props.showNotification({
        level: 'error',
        message: errorMessage
      });
    }

    this.setState(state => {
      return {
        errors: {
          ...state.errors,
          ...errors
        }
      };
    });
    return valid;
  };

  errorValidators = {
    valorTransacaoAvaliacao: declaracaoItbi =>
      validaValorTransacaoAvaliacao(declaracaoItbi),
    valorFinanciadoAvaliacao: declaracaoItbi =>
      validaValorFinanciadoAvaliacao(declaracaoItbi),
    valorIsencao: declaracaoItbi => validaValorIsencao(declaracaoItbi),
    valorIsencaoMaiorItbi: declaracaoItbi =>
      validaValorIsencaoMaiorItbi(declaracaoItbi),
    percentualIsencaoMenorIgualZero: declaracaoItbi =>
      validaPercentualIsencaoMenorIgualZero(declaracaoItbi),
    percentualIsencaoMaiorCem: declaracaoItbi =>
      validaPercentualIsencaoMaiorCem(declaracaoItbi)
  };

  deferir = declaracaoItbi => {
    const { declaracaoService, history } = this.props;

    return new Promise((resolve, reject) => {
      this.setState({
        submitting: true
      });

      declaracaoService
        .deferir(declaracaoItbi.id, this.props.isServidor)
        .then(async response => {
          this.setState({
            submitting: false
          });

          try {
            await Alert.success({
              title: 'Análise Finalizada',
              text: this.deferirSuccessMessage(response.data)
            });

            history.replace(`/declaracoes-itbi/${declaracaoItbi.id}/resumo`);

            resolve(response.data);
          } catch (alertError) {
            console.warn('Erro ao exibir alerta de sucesso:', alertError);
            history.replace(`/declaracoes-itbi/${declaracaoItbi.id}/resumo`);
            resolve(response.data);
          }
        })
        .catch(error => {
          this.setState({
            submitting: false
          });

          Alert.error({ title: 'Falha ao deferir pedido!' }, error);
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            'Erro desconhecido ao deferir declaração';
          reject(errorMessage);
        });
    });
  };

  deferirSuccessMessage = declaracaoItbi => {
    return getDeferirSuccessMessage(declaracaoItbi, {
      includeSetState: true,
      setStateSubmitting: this.setStateSubmitting,
      setState: this.setState
    });
  };

  salvarRascunho = async () => {
    const { isServidor } = this.props;
    const declaracao = this.getDadosDeclaracao();

    const save = declaracao.id
      ? this.props.declaracaoService.updateRascunho
      : this.props.declaracaoService.salvarRascunho;
    const response = await save(declaracao);

    if (response.data) {
      this.setState(
        {
          id: response.data.id
        },
        () => {
          if (
            isServidor ||
            this.state.parametros?.utilizaFluxoAutonomiaCidadao
          ) {
            this.setState(prevState => {
              return {
                dadosIdentificacao: {
                  ...prevState.dadosIdentificacao,
                  vendedores: response.data.vendedores
                },
                dadosImoveis: {
                  ...prevState.dadosImoveis,
                  aliquotaDiferenciadasAplicadas:
                    response.data.aliquotaDiferenciadasAplicadas
                }
              };
            });
          }
        }
      );
      await this.uploadDocumentS3(response.data.id);
      await this.salvarDocumentos();
    }
  };

  salvarDocumentos = async () => {
    const { id, dadosImoveis } = this.state;
    const newDocumentos = dadosImoveis.documentos.map(documento => ({
      id: documento.idDeclaracao,
      documentoItbi: { id: documento.id },
      valor: documento.value?.length > 0 ? documento.value[0].name : '',
      nomesArquivos:
        documento.value?.length > 0
          ? [...documento.value].map(file => `${file.name}`)
          : [],
      campos: documento.campos.map(campo => ({
        id: campo.idCampoDeclaracao,
        campoDocumento: { id: campo.id },
        valor: campo.value ? campo.value : ''
      }))
    }));

    await this.props.declaracaoService.salvarDocumentos(id, newDocumentos);
  };

  uploadDocumentS3 = async declaracao => {
    const { dadosImoveis } = this.state;

    return new Promise(async (resolve, reject) => {
      try {
        const newDocumentos = [];

        for (const documento of dadosImoveis.documentos) {
          if (documento.value?.length > 0 && !documento.uploaded) {
            for (const file of documento.value) {
              const responseUrl = await this.props.uploadService
                .getUrlUploadS3Declaracao({
                  declaracao,
                  documento: documento.id,
                  arquivo: file.name
                })
                .catch(error => {
                  this.props.showNotification({
                    level: 'error',
                    message: `Erro ao gerar URL de upload para o arquivo ${file.name}!`
                  });
                  reject(error);
                });

              await this.props.uploadService
                .uploadFileS3(responseUrl.data.url, file)
                .catch(error => {
                  this.props.showNotification({
                    level: 'error',
                    message: `Falha ao enviar o arquivo ${file.name}!`
                  });
                  reject(error);
                });
            }
          }

          newDocumentos.push({ ...documento, uploaded: true });
        }

        this.setState(
          this.newStateDadosImoveis({ documentos: newDocumentos }),
          () => resolve()
        );
      } catch (error) {
        reject(error);
      }
    });
  };

  getErrorMessage = errors => {
    const arrayErrors = Object.keys(errors)
      .map(field => {
        return {
          field,
          message: errorMessages[field],
          error: errors[field]
        };
      })
      .filter(e => e.error);

    if (arrayErrors.length > 0) {
      return arrayErrors.shift().message;
    }

    return '';
  };

  onBeforeChange = async (oldStepData, newStepData) => {
    const stepDadosImoveis = '1';
    const stepIdentificacao = '2';
    let formValid = {};

    if (newStepData.index < oldStepData.index) {
      return { oldStepData, newStepData };
    }

    if (oldStepData.stepId === stepDadosImoveis) {
      formValid = this.onValidateDadosImoveis(this.state);

      if (formValid.valid) {
        try {
          this.setStateSubmitting('step1', true);
          await this.salvarRascunho();

          this.setStateSubmitting('step1', false);
        } catch (error) {
          formValid.valid = false;
          this.setStateSubmitting('step1', false);
        }
      }
    } else if (oldStepData.stepId === stepIdentificacao) {
      formValid = this.onValidateDadosIdentificacao(this.state);
    }

    const { ...oldStep } = oldStepData;
    oldStep.valid = formValid.valid;
    oldStep.errorMessage = formValid.message;

    return { oldStepData: oldStep, newStepData };
  };

  findNomeRequerente = (requerente = {}) => {
    const { listRequerentes = [] } = this.props;

    const found = listRequerentes.find(item => item.id === requerente.id);

    return (found && found.nome) || requerente.id;
  };

  loadRascunho = id => {
    this.setState({ loadingRascunhoEditar: true });

    this.props.declaracaoService
      .loadDeclaracoesById(id)
      .then(response => {
        const { data } = response;

        if (data) {
          this.setState({
            id: data.id,
            situacaoItbi: data.situacaoItbi,
            tipoItbiOriginal: data.tipoItbi.id,
            valoresOriginais: {
              valorTransacaoAvaliacao: data.valorTransacaoAvaliacao,
              valorTransacaoItbi: data.valorTransacaoItbi,
              valorFinanciadoItbi: data.valorFinanciadoItbi
            },
            dadosImoveis: {
              ...this.state.dadosImoveis,
              requerente: {
                ...data.requerente,
                cpfCnpj: data.requerenteCpfCnpj,
                telefone: data.requerenteTelefone,
                email: data.requerenteEmail,
                nome:
                  data.requerenteNome ||
                  this.findNomeRequerente(data.requerente),
                tipoPessoa: data.requerenteTipoPessoa
              },
              tipoImovel: data.tipoImovel,
              cadastroImobiliario: data.cadastroImobiliario ?? {},
              cadastroRural: data.cadastroRural ?? {},
              tipoItbi: {
                ...data.tipoItbi,
                value: data.tipoItbi.id,
                label: data.tipoItbi.descricao,
                observacao: data.tipoItbi.observacao
              },
              ...(this.state.parametros?.utilizaFluxoAutonomiaCidadao && {
                aliquotaTransacao: data.aliquotaTransacao,
                aliquotaFinanciado: data.aliquotaFinanciado,
                valorTransacaoAvaliacao: data.valorTransacaoAvaliacao,
                valorTransacaoItbi: data.valorTransacaoItbi,
                valorFinanciadoItbi: data.valorFinanciadoItbi,
                valorFinanciadoAvaliacao: data.valorFinanciadoAvaliacao
              }),
              valorTransacao: data.valorTransacao,
              valorFinanciado: data.valorFinanciado,
              valorOriginal: data.valorOriginal,
              retificadora: data.retificadora,
              observacaoCidadao: data.observacaoCidadao,
              documentos: data.documentos.map(documento => ({
                id: documento.documentoItbi.id,
                nome: documento.documentoItbi.nome,
                obrigatorio: documento.documentoItbi.obrigatorio,
                obrigatorioItbiMaisFacil:
                  documento.documentoItbi.obrigatorioItbiMaisFacil,
                value: documento.nomesArquivos?.map(nome => ({
                  name: nome
                })),
                uploaded: true,
                campos: documento.campos.map(campo => ({
                  id: campo.campoDocumento.id,
                  label: campo.campoDocumento.label,
                  tipoCampo: campo.campoDocumento.tipoCampo,
                  value: campo.valor
                }))
              }))
            },
            dadosIdentificacao: {
              ...this.state.dadosIdentificacao,
              vendedores: data.vendedores
                ? data.vendedores
                : this.state.dadosIdentificacao.vendedores,
              compradores: data.compradores
                ? data.compradores
                : this.state.dadosIdentificacao.compradores,
              anuentes: data.anuentes
                ? data.anuentes
                : this.state.dadosIdentificacao.anuentes,
              proprietarios: data.proprietarios
                ? data.proprietarios
                : this.state.dadosIdentificacao.proprietarios
            }
          });

          if (data.tipoItbi && data.documentos.length === 0) {
            this.loadDocumentosPorTipo();
          }

          this.verificarReferenciaItbiMaisFacil(
            data.cadastroImobiliario?.cadastro
          );

          const cadastroParaValidacaoDebitos =
            data.tipoImovel === 'RURAL'
              ? data.cadastroRural
              : data.cadastroImobiliario;

          if (cadastroParaValidacaoDebitos?.cadastro) {
            this.verificarDebitosEmAberto(cadastroParaValidacaoDebitos);
          }

          let tipoItbiResolvidoNoLoad = false;
          if (this.state.parametros?.utilizaFluxoAutonomiaCidadao) {
            const tipoItbiCompleto = this.state.dadosImoveis.listTipoItbi?.find(
              tipo => tipo.value === data.tipoItbi.id
            );

            if (tipoItbiCompleto) {
              this.handleTipoItbiComParametros(tipoItbiCompleto);
              tipoItbiResolvidoNoLoad = true;
            }
          } else {
          }

          if (
            data.situacaoItbi?.name === 'RASCUNHO' &&
            data.tipoImovel === 'URBANO' &&
            data.cadastroImobiliario?.cadastro
          ) {
            this.validarCadastroDoRascunho(
              data.cadastroImobiliario,
              tipoItbiResolvidoNoLoad
            );
          }
        }
      })
      .catch(error => {
        console.error('Erro ao carregar rascunho:', error);
        alert(
          'Não foi possível carregar os dados previamente preenchidos no rascunho!'
        );
      })
      .finally(() => {
        this.setState({ loadingRascunhoEditar: false });
      });
  };

  /**
   * O cadastro do rascunho pode ter sido excluído ou ficado irregular depois que
   * o rascunho foi salvo; revalida como ao informar o cadastro. Os parâmetros
   * precisam estar carregados (bloqueio por inadimplência e englobamento).
   */
  validarCadastroDoRascunho = async (
    cadastroImobiliario,
    tipoItbiResolvidoNoLoad
  ) => {
    if (this.state.parametros === undefined) {
      await this.parametrosPromise;
    }

    if (!this.isEnglobamentoHabilitado()) {
      this.verificarInadimplencia(cadastroImobiliario);
    } else if (!tipoItbiResolvidoNoLoad) {
      // Quando o tipo de ITBI já foi tratado no load (fluxo de autonomia),
      // handleTipoItbiComParametros resolveu o englobamento: não repete.
      this.resolverEnglobamento(cadastroImobiliario);
    }
  };

  //#region dadosImoveis
  newStateDadosImoveis = dados => state => {
    return {
      dadosImoveis: {
        ...state.dadosImoveis,
        ...dados
      }
    };
  };

  setStateSubmitting = (step, submitting) => {
    this.setState(state => ({
      [step]: {
        ...state[step],
        submitting
      }
    }));
  };

  mountlistTipoItbi = listTipoItbi => {
    return listTipoItbi.map(tipoItbi => ({
      ...tipoItbi,
      value: tipoItbi.id,
      label: tipoItbi.descricao
    }));
  };

  handleChangeField = event => {
    const { name, value } = event.target;
    this.setState(state => {
      const { error } = state.dadosImoveis;
      const newError = error[name] ? !value : !!error[name];
      return this.newStateDadosImoveis({
        [name]: value,
        error: { ...error, [name]: newError }
      })(state);
    });
  };

  onChangeValoresItbi = event => {
    const { name, value } = event.target;
    const campoValorItbi = valoresAvaliacao[name].campo;
    const campoAliquota = valoresAvaliacao[name].aliquota;

    const atualizacoes = this.state.parametros?.utilizaFluxoAutonomiaCidadao
      ? this.atualizarCamposCalculo(name, value)
      : { [name]: value };

    if (campoValorItbi === 'valorIsencao') {
      this.setState(state =>
        this.newStateDadosImoveis({
          ...atualizacoes,
          [campoValorItbi]: value,
          percentualIsencao: undefined,
          error: { ...state.dadosImoveis.error, [name]: false }
        })(state)
      );
    } else {
      const parametroItbi = this.state.dadosImoveis.tipoItbi?.parametroItbi;

      const declaracao = {
        ...this.state.dadosImoveis,
        ...atualizacoes,
        tipoItbi: {
          ...this.state.dadosImoveis.tipoItbi,
          normal:
            !this.state.dadosImoveis.tipoItbi?.financiado &&
            !this.state.dadosImoveis.tipoItbi?.anuencia,
          financiado: this.state.dadosImoveis.tipoItbi?.financiado || false,
          anuencia: this.state.dadosImoveis.tipoItbi?.anuencia || false,
          parametroItbi: parametroItbi
        }
      };
      const response = CalculoDeclaracaoitbiUtils.calculaValores(declaracao);

      this.setState(state => {
        const novosDados = {
          ...atualizacoes,
          [campoValorItbi]: +response[campoValorItbi].valor,
          [campoAliquota]: +response[campoValorItbi].aliquota, // Mantém a alíquota atual
          error: { ...state.dadosImoveis.error, [name]: false }
        };

        if (
          state.parametros?.utilizaFluxoAutonomiaCidadao &&
          state.dadosImoveis.retificadora
        ) {
          const valorTransacaoItbi =
            campoValorItbi === 'valorTransacaoItbi'
              ? +response[campoValorItbi]
              : state.dadosImoveis.valorTransacaoItbi;
          const valorFinanciadoItbi =
            state.dadosImoveis.valorFinanciadoItbi || 0;
          const valorOriginal = state.dadosImoveis.valorOriginal || 0;

          const valorTotalITBI = valorTransacaoItbi + valorFinanciadoItbi;
          const valorItbiRetificado = Math.max(
            0,
            valorTotalITBI - valorOriginal
          );

          novosDados.valorItbiRetificado = valorItbiRetificado;
        }

        return this.newStateDadosImoveis(novosDados)(state);
      });
    }
  };

  handleChangeFieldCurrency = ({ floatValue }, event) => {
    const { name } = event.target;
    this.setState(state => {
      const { error } = state.dadosImoveis;
      const newError = error[name] ? !floatValue : !!error[name];
      return this.newStateDadosImoveis({
        [name]: floatValue,
        error: { ...error, [name]: newError }
      })(state);
    });
  };

  atualizarCamposCalculo = (nomeCampo, valor) => {
    const atualizacoes = { [nomeCampo]: valor };

    const campoDestino = CAMPOS_SINCRONIZADOS[nomeCampo];
    if (campoDestino) {
      atualizacoes[campoDestino] = valor;
    }

    return atualizacoes;
  };

  error = (nomeCampo, valor) => {
    const { error } = this.state.dadosImoveis;
    return error[nomeCampo] ? !valor : !!error[nomeCampo];
  };

  handleChangeFieldDocument = event => {
    const { id, value, checked, type } = event.target;
    const idDocumento = event.target.getAttribute('data-id');
    let newDocumentos = [...this.state.dadosImoveis.documentos];
    const newValue = type === 'checkbox' ? checked : value;
    const documento = newDocumentos.find(f => f.id === idDocumento);
    documento.campos.map(field => {
      if (`${field.id}` === `${id}`) {
        field.value = newValue;
        field.error = false;
        field.errorMessage = '';
      }
      return field;
    });
    this.setState(
      this.newStateDadosImoveis({
        documentos: newDocumentos
      })
    );
  };

  tamanhoValido = files => {
    return [...files].length > 0
      ? [...files].some(file => file.size <= 50000000)
      : true;
  };

  handleChangeUploadFile = event => {
    const { files } = event.target;
    const idDocumento = event.target.getAttribute('data-id');
    let newDocumentos = [...this.state.dadosImoveis.documentos];
    const documento = newDocumentos.find(f => f.id === idDocumento);

    if (this.tamanhoValido(files)) {
      documento.value =
        documento.value?.length > 0 ? [...documento.value, ...files] : files;
      documento.error = false;
      documento.errorMessage = '';
      documento.uploaded = false;
    } else {
      documento.error = true;
      documento.errorMessage = errorMessages.documentoTamanho;
      documento.uploaded = false;
    }
    this.setState(
      this.newStateDadosImoveis({
        documentos: newDocumentos
      })
    );
  };

  handleRemoveFile = (idDocumento, index) => {
    let newDocumentos = [...this.state.dadosImoveis.documentos];
    const documento = newDocumentos.find(f => f.id === idDocumento);
    documento.value = [...documento.value];
    documento.value.splice(index, 1);
    this.setState(
      this.newStateDadosImoveis({
        documentos: newDocumentos
      })
    );
  };

  handleChangeCadastroImobiliario = event => {
    const { isServidor } = this.props;
    const { name, value } = event.target;
    this.chaveDebitosConsultada = null;
    this.setState(state => {
      const { error } = state.dadosImoveis;
      const newError = error[name] ? !value : !!error[name];
      const imobiliario = isServidor
        ? state.dadosImoveis.cadastroImobiliario
        : this.imobiliarioEmpty;

      return this.newStateDadosImoveis({
        imovelNotFoundByCadastro: false,
        imovelNotFoundByInscricaoCadastral: false,
        cadastroImobiliario: { ...imobiliario, [name]: value },
        error: { ...error, [name]: newError }
      })(state);
    });
  };

  handleChangeCadastroRural = event => {
    const { name, value } = event.target;
    this.chaveDebitosConsultada = null;
    this.setState(state => {
      const { error } = state.dadosImoveis;
      const newError = error[name] ? !value : !!error[name];

      const oldRural = state.dadosImoveis.cadastroRural ?? {};

      return this.newStateDadosImoveis({
        ruralNotFound: false,
        cadastroRural: { ...oldRural, [name]: value },
        error: { ...error, [name]: newError }
      })(state);
    });
  };

  handleClearCadastroImobiliario = () => {
    this.chaveDebitosConsultada = null;
    this.setState(
      this.newStateDadosImoveis({
        imovelNotFoundByCadastro: false,
        imovelNotFoundByInscricaoCadastral: false,
        cadastroImobiliario: { ...this.imobiliarioEmpty }
      })
    );
  };

  resetAnuentes = () => {
    this.setState(state => ({
      dadosIdentificacao: {
        ...state.dadosIdentificacao,
        anuentes: []
      }
    }));
  };

  handleTipoItbiComParametros = async tipoItbi => {
    try {
      const parametroItbi = tipoItbi.parametroItbi;

      const isTipoItbiOriginal =
        this.state.id && tipoItbi.value === this.state.tipoItbiOriginal;

      this.setState(
        state => ({
          dadosImoveis: {
            ...state.dadosImoveis,
            ...prepareDadosImoveisState(parametroItbi, tipoItbi, state)
          }
        }),
        () => {
          if (!isTipoItbiOriginal) {
            this.setState(state => ({
              dadosImoveis: {
                ...state.dadosImoveis,
                valorTransacaoItbi: 0,
                valorFinanciadoItbi: 0,
                valorFinanciado: undefined,
                valorFinanciadoAvaliacao: undefined
              }
            }));
          } else {
            const valorAvaliacao = this.state.dadosImoveis
              .valorTransacaoAvaliacao;

            if (valorAvaliacao && valorAvaliacao > 0) {
              this.sincronizarCampos(valorAvaliacao);
            }
          }

          this.loadDocumentosPorTipo();
          this.resetAnuentes();
          this.resolverEnglobamento(
            this.state.dadosImoveis.cadastroImobiliario
          );
        }
      );
    } catch (error) {
      console.error('Erro ao carregar parâmetros ITBI:', error);
      this.props.showNotification({
        level: 'error',
        message: 'Erro ao carregar parâmetros ITBI'
      });
    }
  };

  handleTipoItbiSimples = async tipoItbi => {
    this.setState(
      state => ({
        dadosImoveis: {
          ...state.dadosImoveis,
          tipoItbi: tipoItbi || {},
          valorFinanciado:
            tipoItbi && (tipoItbi.financiado || tipoItbi.anuencia)
              ? state.dadosImoveis.valorFinanciado
              : undefined,
          error: {
            ...state.dadosImoveis.error,
            tipoItbi: false,
            loadDocumentos: false
          }
        }
      }),
      () => {
        this.loadDocumentosPorTipo();
        this.resetAnuentes();
      }
    );
  };

  handleChangeSelectTipoItbi = async event => {
    const { value } = event.target;
    const { dadosImoveis } = this.state;

    if (dadosImoveis.tipoItbi.value === value) {
      return;
    }

    this.setState(state => ({
      itbiMaisFacil: { ...state.itbiMaisFacil, aceitou: null }
    }));

    try {
      const tipoItbi = dadosImoveis.listTipoItbi.find(
        tipo => tipo.value === value
      );

      if (!tipoItbi) {
        console.warn('Tipo ITBI não encontrado:', value);
        return;
      }

      if (this.state.parametros?.utilizaFluxoAutonomiaCidadao) {
        await this.handleTipoItbiComParametros(tipoItbi);
      } else {
        await this.handleTipoItbiSimples(tipoItbi);
      }

      if (
        tipoItbi.utilizaMaisFacil &&
        this.state.dadosImoveis?.temValorReferenciaItbiMaisFacil &&
        !this.props.isServidor
      ) {
        const cadastro = this.state.dadosImoveis?.cadastroImobiliario?.cadastro;
        if (cadastro) {
          this.abrirModalMaisFacil(cadastro, tipoItbi);
        }
      }
    } catch (error) {
      console.error('Erro ao alterar tipo ITBI:', error);
      this.props.showNotification({
        level: 'error',
        message: 'Erro ao alterar tipo ITBI'
      });
    }
  };

  sincronizarCampos = valorAvaliacao => {
    const event = {
      target: {
        name: 'valorTransacaoAvaliacao',
        value: valorAvaliacao
      }
    };
    this.onChangeValoresItbi(event);
  };

  handleChangeSelectRequerente = event => {
    const { value } = event.target;
    const { listRequerentes = [] } = this.props;

    const requerente = listRequerentes.find(item => item.id === value);

    this.setState(state => {
      const { error } = state.dadosImoveis;

      return this.newStateDadosImoveis({
        requerente: requerente || {},
        error: {
          ...error,
          requerente: {
            id: false
          }
        }
      })(state);
    });
  };

  handleKeyDownCadastroImobiliario = event => {
    const enterKey = 13;
    if ([enterKey].includes(event.keyCode)) {
      this.onSearchCadastroImobiliario(event.target.name, event.target.value);
    }
  };

  handleBlurCadastroImobiliario = event => {
    this.onSearchCadastroImobiliario(event.target.name, event.target.value);
  };

  loadDocumentosPorTipo = () => {
    const { dadosImoveis } = this.state;

    if (!dadosImoveis.tipoItbi.value) {
      this.setState(this.newStateDadosImoveis({ documentos: [] }));
    } else {
      this.props.parametroService
        .loadDocumentoByTipoItbi(dadosImoveis.tipoItbi.value)
        .then(response => {
          if (response.data) {
            this.setState(
              this.newStateDadosImoveis({ documentos: response.data })
            );
          }
        })
        .catch(() =>
          this.setState(
            this.newStateDadosImoveis({ error: { loadDocumentos: true } })
          )
        );
    }
  };

  shouldFindByInscricaoCadastral = search => {
    const { parametros, dadosImoveis } = this.state;
    const { inscricaoCadastral } = dadosImoveis.cadastroImobiliario;

    return (
      parametros?.buscaImobiliarioPorInscricao && inscricaoCadastral === search
    );
  };

  findByInscricaoCadastral = search => {
    this.setState(
      this.newStateDadosImoveis({ cadastroImobiliarioLoading: true })
    );

    const { isServidor, imobiliarioService } = this.props;

    return imobiliarioService
      .findByInscricaoCadastral(search)
      .then(response => {
        if (response.data) {
          this.setState(
            prevState => {
              return {
                dadosImoveis: {
                  ...prevState.dadosImoveis,
                  cadastroImobiliario: { ...response.data },
                  imovelNotFoundByInscricaoCadastral: false,
                  error: {
                    ...prevState.dadosImoveis.error,
                    inscricaoCadastral: false
                  }
                }
              };
            },
            () => {
              if (isServidor) {
                this.setState(prevState => {
                  return {
                    dadosIdentificacao: {
                      ...prevState.dadosIdentificacao,
                      vendedores: this.convertProprietariosToVendedores(
                        response?.data?.proprietarios
                      )
                    }
                  };
                });
              }

              if (
                !isServidor &&
                this.state.parametros?.utilizaFluxoAutonomiaCidadao
              ) {
                this.setState(prevState => {
                  return {
                    dadosIdentificacao: {
                      ...prevState.dadosIdentificacao,
                      vendedores: this.convertProprietariosToVendedores(
                        response?.data?.proprietarios
                      )
                    }
                  };
                });
              }
            }
          );
        }
        return response;
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.setState(
            this.newStateDadosImoveis({
              imovelNotFoundByInscricaoCadastral: true
            })
          );
        } else {
          this.setState(prevState => {
            return {
              dadosImoveis: {
                ...prevState.dadosImoveis,
                error: {
                  ...prevState.dadosImoveis.error,
                  inscricaoCadastral: true
                }
              }
            };
          });
        }
      })
      .finally(() =>
        this.setState(
          this.newStateDadosImoveis({
            cadastroImobiliarioLoading: false
          })
        )
      );
  };

  findCadastroImobiliario = (fieldName, fieldValue) => {
    this.setState(
      this.newStateDadosImoveis({ cadastroImobiliarioLoading: true })
    );

    const { isServidor, imobiliarioService } = this.props;

    return imobiliarioService
      .findCadastroFormSelect({ [fieldName]: fieldValue })
      .then(response => {
        if (response.data) {
          this.setState(
            prevState => ({
              dadosImoveis: {
                ...prevState.dadosImoveis,
                cadastroImobiliario: { ...response.data },
                error: {
                  ...prevState.dadosImoveis.error,
                  cadastro: false,
                  inscricaoCadastral: false,
                  matricula: false
                }
              }
            }),
            () => {
              if (
                isServidor ||
                this.state.parametros?.utilizaFluxoAutonomiaCidadao
              ) {
                this.setState(prevState => {
                  return {
                    dadosIdentificacao: {
                      ...prevState.dadosIdentificacao,
                      vendedores: this.convertProprietariosToVendedores(
                        response?.data?.proprietarios
                      )
                    }
                  };
                });
              }
            }
          );
        }
        return response;
      })
      .catch(error => {
        // Sem return: o loading do finally não pode esperar o clique no OK.
        this.avisarCadastroBloqueado(() =>
          Alert.error({ title: `Não foi possível concluir a ação ` }, error)
        );
        this.setState(prevState => ({
          dadosImoveis: {
            ...prevState.dadosImoveis,
            error: {
              ...prevState.dadosImoveis.error,
              [fieldName]: true
            }
          }
        }));
      })
      .finally(() =>
        this.setState(
          this.newStateDadosImoveis({
            cadastroImobiliarioLoading: false
          })
        )
      );
  };

  isEnglobamentoHabilitado = () =>
    this.state.dadosImoveis.tipoImovel === 'URBANO' &&
    !!this.state.dadosImoveis.tipoItbi?.parametroItbi
      ?.transfereUnidadesEnglobadas;

  limparEnglobamento = () =>
    this.setState(
      this.newStateDadosImoveis({
        englobados: [],
        cadastroPaiEnglobamento: undefined,
        cadastroSelecionadoEnglobamento: undefined
      })
    );

  resolverEnglobamento = cadastroData => {
    const cadastroSelecionado = cadastroData?.cadastro;

    if (!this.isEnglobamentoHabilitado() || !cadastroSelecionado) {
      this.limparEnglobamento();
      return Promise.resolve();
    }

    return this.props.imobiliarioService
      .resolverEnglobamento(cadastroSelecionado)
      .then(response => {
        const englobamento = response?.data;
        if (!englobamento || !(englobamento.englobados?.length > 0)) {
          this.limparEnglobamento();
          this.verificarInadimplencia(cadastroData);
          this.verificarDebitosEmAberto(cadastroData);
          return;
        }

        this.setState(
          this.newStateDadosImoveis({
            englobados: englobamento.englobados,
            cadastroPaiEnglobamento: englobamento.cadastroPai,
            cadastroSelecionadoEnglobamento: Number(cadastroSelecionado)
          })
        );

        const validarEnglobados = () => {
          this.verificarInadimplenciaEnglobados(
            englobamento.englobados,
            cadastroData.tipoCadastro
          );
          this.verificarDebitosEmAbertoEnglobados(
            englobamento.englobados,
            cadastroData.tipoCadastro
          );
        };

        if (englobamento.cadastroPai !== Number(cadastroSelecionado)) {
          // A validação só começa com o cadastro pai já carregado: assim o aviso
          // bloqueante e a limpeza do cadastro são sempre o último passo e
          // nenhuma resposta pendente reabre o imóvel depois deles.
          return this.findCadastroImobiliario(
            'cadastro',
            String(englobamento.cadastroPai)
          ).then(resposta => resposta && validarEnglobados());
        }

        return validarEnglobados();
      })
      .catch(() => {
        this.limparEnglobamento();
        this.verificarInadimplencia(cadastroData);
        this.verificarDebitosEmAberto(cadastroData);
      });
  };

  verificarInadimplenciaEnglobados = (englobados, tipoCadastro) => {
    const bloqueiaItbiCadInadimplente = this.state.parametros
      ?.bloqueiaItbiCadInadimplente;
    const { cadastroGeralService } = this.props;
    this.setState({ loadingInadimplencia: true });

    return Promise.all(
      englobados.map(englobado =>
        cadastroGeralService
          .isInadimplente(tipoCadastro, englobado.cadastroGeral)
          .then(response => ({
            cadastro: englobado.cadastroGeral,
            inadimplente: response.data
          }))
      )
    )
      .then(resultados => {
        const inadimplentes = resultados
          .filter(resultado => resultado.inadimplente)
          .map(resultado => resultado.cadastro);

        this.setState({
          loadingInadimplencia: false,
          isCadastroInadimplente: inadimplentes.length > 0
        });

        if (inadimplentes.length > 0 && bloqueiaItbiCadInadimplente) {
          this.avisarCadastroBloqueado(() =>
            Alert.warning({
              title: 'Atenção',
              text: `Não é possível realizar o pedido, pois os cadastros ${inadimplentes.join(
                ', '
              )} se encontram irregulares. Entre em contato com o município para regularização.`
            })
          );
        }
      })
      .catch(err => {
        this.setState({ loadingInadimplencia: false });
        this.tratarErroValidacaoCadastro(err);
      });
  };

  verificarDebitosEmAbertoEnglobados = async (englobados, tipoCadastro) => {
    if (this.state.parametros === undefined) {
      await this.parametrosPromise;
    }

    if (!this.state.parametros?.avisaDebitoAbertoItbi) {
      return;
    }

    const chaveDebitos = englobados
      .map(englobado => `${tipoCadastro}-${englobado.cadastroGeral}`)
      .join('|');

    if (this.chaveDebitosConsultada === chaveDebitos) {
      return;
    }
    this.chaveDebitosConsultada = chaveDebitos;

    const { debitoService } = this.props;
    this.setState({
      loadingDebitos: true,
      avisoDebitosVisible: false,
      avisoDebitosExpandido: false,
      debitosEmAberto: undefined
    });

    return Promise.all(
      englobados.map(englobado =>
        debitoService
          .getDebitosEmAberto(tipoCadastro, englobado.cadastroGeral)
          .then(response => response.data)
      )
    )
      .then(resultados => {
        const somar = campo =>
          resultados.reduce(
            (total, resultado) => total + (resultado?.[campo] ?? 0),
            0
          );
        const debitos = resultados.reduce(
          (lista, resultado) => lista.concat(resultado?.debitos ?? []),
          []
        );

        const debitosEmAberto = {
          debitos,
          valorPrincipal: somar('valorPrincipal'),
          valorAcrescimos: somar('valorAcrescimos'),
          valorDescontos: somar('valorDescontos'),
          valorTotal: somar('valorTotal')
        };
        const possuiDebitos = debitos.length > 0;

        this.setState({
          loadingDebitos: false,
          debitosEmAberto,
          avisoDebitosVisible: possuiDebitos,
          avisoDebitosExpandido: false
        });

        if (possuiDebitos) {
          Alert.warning({
            title: 'Atenção',
            text: 'Um ou mais cadastros englobados possuem débitos em aberto.'
          });
        }
      })
      .catch(err => {
        this.chaveDebitosConsultada = null;
        this.setState({ loadingDebitos: false });
        Alert.error(
          { title: 'Não foi possível verificar débitos em aberto do cadastro' },
          err
        );
      });
  };

  verificarReferenciaItbiMaisFacil = cadastro => {
    if (!cadastro || !this.state.parametros?.utilizaItbiMaisFacil) {
      return;
    }
    this.setState(state => ({
      itbiMaisFacil: { ...state.itbiMaisFacil, aceitou: null }
    }));
    this.props.declaracaoService
      .existeReferenciaItbiMaisFacil(cadastro)
      .then(response => {
        const existe = response.data === true;
        this.setState(
          this.newStateDadosImoveis({
            temValorReferenciaItbiMaisFacil: existe
          })
        );
        const tipoItbi = this.state.dadosImoveis?.tipoItbi;
        const tipoMaisFacil = tipoItbi?.value && tipoItbi?.utilizaMaisFacil;
        if (existe && tipoMaisFacil && !this.props.isServidor) {
          this.abrirModalMaisFacil(cadastro, tipoItbi);
        }
      })
      .catch(() => {
        this.setState(
          this.newStateDadosImoveis({ temValorReferenciaItbiMaisFacil: false })
        );
      });
  };

  abrirModalMaisFacil = (cadastro, tipoItbi) => {
    this.props.declaracaoService
      .simularItbiMaisFacil(cadastro, tipoItbi.value)
      .then(response => {
        const dados = response.data;
        if (dados?.disponivel) {
          this.setState(state => ({
            itbiMaisFacil: {
              ...state.itbiMaisFacil,
              visible: true,
              dados,
              isFinanciado: !!tipoItbi.financiado
            }
          }));
        }
      })
      .catch(() => {});
  };

  onSearchCadastroImobiliario = (fieldName, value) => {
    if (!value) return;
    return this.findCadastroImobiliario(fieldName, value).then(res => {
      if (res) {
        this.verificarReferenciaItbiMaisFacil(res.data?.cadastro);
        if (this.isEnglobamentoHabilitado()) {
          this.resolverEnglobamento(res.data);
        } else {
          this.verificarInadimplencia(res.data);
          this.verificarDebitosEmAberto(res.data);
        }
      }
    });
  };

  handleSelectCadastroPesquisa = cadastroGeral => {
    if (this.state.dadosImoveis.tipoImovel === 'URBANO') {
      this.onSearchCadastroImobiliario('cadastro', String(cadastroGeral));
    } else {
      this.searchCadastroRural('cadastro', cadastroGeral);
    }
  };

  handleBlurCadastroRural = event => {
    this.searchCadastroRural(event.target.name, event.target.value);
  };

  searchCadastroRural = (fieldName, fieldValue) => {
    if (!fieldValue) {
      return;
    }
    this.setState(this.newStateDadosImoveis({ cadastroRuralLoading: true }));

    const { isServidor, cadastroRuralService } = this.props;

    return cadastroRuralService
      .findCadastroFormSelect({ [fieldName]: fieldValue })
      .then(response => {
        if (response.data) {
          this.verificarDebitosEmAberto(response.data);
          this.setState(
            prevState => {
              return {
                dadosImoveis: {
                  ...prevState.dadosImoveis,
                  cadastroRural: { ...response.data },
                  ruralNotFound: false,
                  error: {
                    ...prevState.dadosImoveis.error,
                    cadastro: false,
                    matricula: false
                  }
                }
              };
            },
            () => {
              if (
                isServidor ||
                this.state.parametros?.utilizaFluxoAutonomiaCidadao
              ) {
                this.setState(prevState => {
                  return {
                    dadosIdentificacao: {
                      ...prevState.dadosIdentificacao,
                      vendedores: this.convertProprietariosToVendedores(
                        response?.data?.proprietarios
                      )
                    }
                  };
                });
              }
            }
          );
        }
        return response;
      })
      .catch(error => {
        Alert.error({ title: `Não foi possível concluir a ação ` }, error);
        this.setState(prevState => {
          return {
            dadosImoveis: {
              ...prevState.dadosImoveis,
              cadastroRural: {
                [fieldName]: fieldValue
              },
              ruralNotFound: error.response && error.response.status === 404,
              error: {
                ...prevState.dadosImoveis.error,
                [fieldName]: true
              }
            }
          };
        });
      })
      .finally(() =>
        this.setState(
          this.newStateDadosImoveis({ cadastroRuralLoading: false })
        )
      );
  };

  onValidateDadosImoveis = ({ dadosImoveis }) => {
    const { isServidor } = this.props;
    const { parametros } = this.state;
    const { tipoItbi, tipoImovel } = dadosImoveis;
    const { error } = dadosImoveis;

    const isInvalidValorTransacao =
      !dadosImoveis.valorTransacao || dadosImoveis.valorTransacao <= 0;

    let message = '';

    error.tipoItbi = !tipoItbi.value;

    error.valorTransacao =
      (tipoItbi.financiado || tipoItbi.anuencia) &&
      tipoItbi.permiteTotalmenteFinanciado
        ? false
        : parametros?.utilizaFluxoAutonomiaCidadao
        ? false
        : isInvalidValorTransacao;

    error.valorFinanciado =
      (tipoItbi.financiado || tipoItbi.anuencia) &&
      (!dadosImoveis.valorFinanciado || dadosImoveis.valorFinanciado <= 0);

    error.cadastro =
      tipoImovel === 'URBANO' && dadosImoveis.cadastroImobiliario.cadastro <= 0;

    error.inscricaoCadastral =
      tipoImovel === 'URBANO' &&
      parametros?.buscaImobiliarioPorInscricao &&
      dadosImoveis.cadastroImobiliario.inscricaoCadastral <= 0;

    const permiteCriacaoCadastroRuralItbi = !!parametros?.permiteCriacaoCadastroRuralItbi;

    const cadastroRuralSemCodigo =
      tipoImovel === 'RURAL' && (dadosImoveis.cadastroRural.cadastro ?? 0) <= 0;

    error.cadastro =
      tipoImovel === 'RURAL'
        ? cadastroRuralSemCodigo && !permiteCriacaoCadastroRuralItbi
        : error.cadastro;

    error.enderecoDescrito =
      cadastroRuralSemCodigo &&
      permiteCriacaoCadastroRuralItbi &&
      !dadosImoveis.cadastroRural.enderecoDescrito;

    error.matricula =
      error.cadastro &&
      error.matricula &&
      (tipoImovel === 'URBANO' ||
        (tipoImovel === 'RURAL' && !permiteCriacaoCadastroRuralItbi));

    error.numeroEndereco = dadosImoveis.cadastroImobiliario.numero?.length > 10;

    error.documentos = this.validateDocumentos(dadosImoveis);

    error.requerente = { id: !isServidor && !dadosImoveis.requerente.id };

    error.cadastroInadimplente =
      this.state.isCadastroInadimplente &&
      this.state.parametros.bloqueiaItbiCadInadimplente;

    error.valorItbiRetificado =
      !isServidor &&
      parametros?.utilizaFluxoAutonomiaCidadao &&
      dadosImoveis.retificadora &&
      (dadosImoveis.valorItbiRetificado || 0) <= 0;

    if (isServidor) {
      error.requerente.tipoPessoa = !dadosImoveis.requerente.tipoPessoa;
      error.requerente.cpfCnpj = !dadosImoveis.requerente.cpfCnpj;
      error.requerente.nome = !dadosImoveis.requerente.nome;
      error.requerente.nomeLength = dadosImoveis.requerente.nome.length > 150;
      error.requerente.emailInvalid = !isValidEmail(
        dadosImoveis.requerente.email
      );
    }

    this.setState(this.newStateDadosImoveis({ error }));

    const valid =
      !Object.values(error).includes(true) &&
      !Object.values(error.requerente).includes(true);

    if (!valid) {
      // Mensagem específica para valor ITBI retificado
      if (error.valorItbiRetificado) {
        message = 'O valor do ITBI refitificado deve ser maior que zero!';
        this.props.showNotification({
          level: 'error',
          message: 'O valor do ITBI refitificado deve ser maior que zero!'
        });
      } else {
        message = 'Campos Obrigatórios!';
        this.props.showNotification({
          level: 'error',
          message: 'Campos Obrigatórios!'
        });
      }
    }

    this.setState({
      step1: {
        ...this.state.step1,
        valid,
        errorMessage: message
      }
    });

    return { valid, message, error };
  };

  validaDocumento = documento => {
    const {
      obrigatorio,
      obrigatorioItbiMaisFacil,
      value,
      uploaded
    } = documento;
    const utilizaMaisFacil = this.state.dadosImoveis?.tipoItbi
      ?.utilizaMaisFacil;
    const aceitouMaisFacil = this.state.itbiMaisFacil?.aceitou === true;
    const isDispensado =
      utilizaMaisFacil &&
      obrigatorioItbiMaisFacil === false &&
      aceitouMaisFacil;

    if (obrigatorio && !isDispensado && (!value || value.length === 0)) {
      return {
        error: true,
        errorMessage: errorMessages.documentoObrigatorio
      };
    }

    if (!uploaded && value && !this.tamanhoValido(value)) {
      return {
        error: true,
        errorMessage: errorMessages.documentoTamanho
      };
    }

    return {
      error: false,
      errorMessage: ''
    };
  };

  validateDocumentos = ({ documentos }) => {
    if (documentos.length === 0) {
      return false;
    }
    const newDocumentos = documentos.map(documento => {
      const erroDocumento = this.validaDocumento(documento);

      return {
        ...documento,
        error: erroDocumento.error,
        errorMessage: erroDocumento.errorMessage,
        campos: documento.campos.map(field => {
          const utilizaMaisFacil = this.state.dadosImoveis?.tipoItbi
            ?.utilizaMaisFacil;
          const aceitouMaisFacil = this.state.itbiMaisFacil?.aceitou === true;
          const campoHasError =
            documento.obrigatorio &&
            !(
              utilizaMaisFacil &&
              documento.obrigatorioItbiMaisFacil === false &&
              aceitouMaisFacil
            ) &&
            !field.value;
          return {
            ...field,
            error: campoHasError,
            errorMessage: campoHasError ? `${field.label} é obrigatório!` : ''
          };
        })
      };
    });
    this.setState(this.newStateDadosImoveis({ documentos: newDocumentos }));

    return (
      newDocumentos.some(doc => doc.error) ||
      newDocumentos
        .map(({ campos }) => campos)
        .reduce((accum, valor) => accum.concat(valor), [])
        .some(campo => campo.error)
    );
  };

  //#endregion dadosImoveis

  faltaDocumentoProcuracaoDeRequerente = (dadosImoveis, dadosIdentificacao) => {
    const isRequerenteEntreOsCompradores = this.requerenteInList(
      dadosImoveis.requerente,
      dadosIdentificacao.compradores
    );
    const documentosQueExigemProcuracao = dadosImoveis.documentos.filter(
      documento => documento.procuracaoRequerente
    );
    const documentosComProcuracaoAssinada = documentosQueExigemProcuracao.filter(
      documento => documento.value
    );
    return (
      documentosQueExigemProcuracao.length !==
        documentosComProcuracaoAssinada.length &&
      !isRequerenteEntreOsCompradores
    );
  };

  //#region identificacao
  onValidateDadosIdentificacao = ({ dadosIdentificacao, dadosImoveis }) => {
    const { error } = dadosIdentificacao;
    const { parametros } = this.state;
    let message = '';

    error.documentoProcuracaoRequerente = this.faltaDocumentoProcuracaoDeRequerente(
      dadosImoveis,
      dadosIdentificacao
    );

    error.compradores = dadosIdentificacao.compradores.length === 0;

    error.compradorIncompleto = parametros?.validaRgComprador
      ? this.possuiCompradorSemRg(dadosIdentificacao.compradores)
      : false;

    error.vendedores = dadosIdentificacao.vendedores.length === 0;

    if (dadosImoveis.tipoItbi.anuencia) {
      error.anuentes = dadosIdentificacao.anuentes.length === 0;
    }

    error.percentualCompraVenda = this.validatePercentualCompraVenda(
      dadosIdentificacao
    );
    if (
      dadosImoveis.tipoItbi?.utilizaTramitacaoAutomatica ||
      (!this.props.isServidor &&
        (parametros?.utilizaFluxoAutonomiaCidadao ||
          parametros?.utilizaItbiMaisFacil))
    ) {
      const temProprietarios = dadosIdentificacao.proprietarios.length > 0;
      error.proprietarios = !temProprietarios;

      if (temProprietarios) {
        const percentualTotalProprietarios = this.getPercentual(
          dadosIdentificacao.proprietarios
        );
        error.percentualProprietarios = percentualTotalProprietarios !== 100;

        error.vinculoProprietarios = this.validateVinculo(
          dadosIdentificacao.proprietarios
        );
      }
    }

    if (formatUtils.isCpf(dadosImoveis.requerente.cpfCnpj)) {
      error.requerenteCompradorVendedor = false;

      error.requerenteComprador = this.validateRequerenteComprador(
        dadosImoveis,
        dadosIdentificacao
      );
    } else {
      error.requerenteComprador = false;

      error.requerenteCompradorVendedor = this.validateRequerenteParteProcesso(
        dadosImoveis,
        dadosIdentificacao
      );
    }

    this.setState(this.newStateDadosIdentificacao({ error }));
    const valid = !Object.values(error).includes(true);

    if (!valid) {
      message = 'Formulário inválido!';
      this.props.showNotification({
        level: 'error',
        message:
          this.getErrorMessage(this.state.dadosIdentificacao.error) !== ''
            ? this.getErrorMessage(this.state.dadosIdentificacao.error)
            : message
      });
    }

    this.setState({
      step2: {
        ...this.state.step2,
        valid,
        errorMessage: message
      }
    });

    return { valid, message };
  };

  possuiCompradorSemRg = compradores => {
    return compradores.some(
      comprador =>
        comprador.tipoPessoa === 'FISICA' &&
        (!comprador.rg || !comprador.rgOrgaoEmissor || !comprador.rgUf)
    );
  };

  validatePercentualCompraVenda = ({ compradores, vendedores }) => {
    const percentualCompra = this.getPercentual(compradores);
    const percentualVendedores = this.getPercentualVenda(vendedores);

    return (
      formatUtils.round(percentualCompra, 2) !==
      formatUtils.round(percentualVendedores, 2)
    );
  };

  validateVinculo = proprietarios => {
    return proprietarios.some(proprietario => !proprietario.vinculo);
  };

  validateRequerenteComprador = ({ requerente }, { compradores }) => {
    if (this.props.isServidor || this.state.parametros?.naoValidaRequerente) {
      return false;
    }

    return (
      !requerente.procurador && !this.requerenteInList(requerente, compradores)
    );
  };

  validateRequerenteParteProcesso = (
    { requerente },
    { compradores, vendedores, anuentes }
  ) => {
    if (this.props.isServidor) {
      return false;
    }

    return (
      !requerente.procurador &&
      !this.requerenteInList(requerente, compradores) &&
      !this.requerenteInList(requerente, vendedores) &&
      !this.requerenteInList(requerente, anuentes)
    );
  };

  requerenteInList = (requerente, list) =>
    list && list.some(m => m.cpfCnpj === requerente.cpfCnpj);

  getPercentual = array => {
    return array
      .map(m => +m.percentual)
      .reduce((accum, valor) => accum + valor, 0);
  };

  getPercentualVenda = array => {
    return array
      .map(m => +m.percentualVenda)
      .reduce((accum, valor) => accum + valor, 0);
  };

  newStateDadosIdentificacao = dados => state => {
    return {
      dadosIdentificacao: {
        ...state.dadosIdentificacao,
        ...dados
      }
    };
  };

  adicionarListaIdentificadores = (
    fieldName,
    pluralFieldName,
    addFn
  ) => async value => {
    const { [pluralFieldName]: lista } = this.state.dadosIdentificacao;
    const error = {
      ...this.state.dadosIdentificacao.error,
      [pluralFieldName]: false
    };
    try {
      await addFn(this.state.id, value).then(response => {
        const newValue = { ...value, id: response.data.id };
        const newLista = [...lista, newValue];
        this.setState(
          this.newStateDadosIdentificacao({
            [pluralFieldName]: newLista,
            error
          })
        );
      });
    } catch (error) {
      Alert.error({ title: `Falha ao adicionar ${fieldName}!` }, error);
    }
  };

  adicionarAnuente = this.adicionarListaIdentificadores(
    'anuente',
    'anuentes',
    this.props.declaracaoService.updateAnuentes
  );

  adicionarComprador = async comprador => {
    await this.adicionarListaIdentificadores(
      'comprador',
      'compradores',
      this.props.declaracaoService.updateCompradores
    )(comprador);

    await this.sincronizarProprietarios();
  };

  adicionarVendedor = async vendedor => {
    await this.adicionarListaIdentificadores(
      'vendedor',
      'vendedores',
      this.props.declaracaoService.updateVendedores
    )(vendedor);

    await this.sincronizarProprietarios();
  };

  adicionarProprietario = this.adicionarListaIdentificadores(
    'proprietario',
    'proprietarios',
    this.props.declaracaoService.updateProprietarios
  );

  adicionarProprietarioCidadao = async proprietario => {
    const { proprietarios } = this.state.dadosIdentificacao;
    const proprietarioExistente = proprietarios.find(
      proprietarioAtual => proprietarioAtual.cpfCnpj === proprietario.cpfCnpj
    );

    if (proprietarioExistente) {
      this.props.showNotification({
        level: 'error',
        message:
          'Este proprietário já consta no novo quadro de proprietários. Edite a linha existente para ajustar o percentual.'
      });

      throw new Error('Proprietário já consta no quadro da declaração.');
    }

    await this.adicionarListaIdentificadores(
      'proprietario',
      'proprietarios',
      this.props.declaracaoService.updateProprietarios
    )(proprietario);

    await this.sincronizarProprietarios();
  };

  editarListaIdentificadores = (fieldName, pluralFieldName, updateFn) => async (
    value,
    posicao
  ) => {
    const { [pluralFieldName]: lista } = this.state.dadosIdentificacao;

    try {
      await updateFn(this.state.id, value).then(response => {
        const elementoAtualizado = {
          ...value,
          id: value.id || response.data.id
        };
        const newLista = lista
          .slice(0, posicao)
          .concat([elementoAtualizado])
          .concat(lista.slice(posicao + 1));

        this.setState(
          this.newStateDadosIdentificacao({ [pluralFieldName]: newLista })
        );
      });
    } catch (error) {
      Alert.error(
        {
          title: `Falha ao atualizar ${fieldName}!`
        },
        error
      );
    }
  };

  deletarListaIdentificadores = (
    fieldName,
    pluralFieldName,
    deleteFn
  ) => async posicao => {
    const { [pluralFieldName]: lista } = this.state.dadosIdentificacao;
    const elemento = lista[posicao];
    const newLista = lista.slice(0, posicao).concat(lista.slice(posicao + 1));
    try {
      this.setState({ loadingRascunhoEditar: true });
      await deleteFn(this.state.id, elemento.id).then(() => {
        this.setState(
          this.newStateDadosIdentificacao({ [pluralFieldName]: newLista })
        );
        this.setState({ loadingRascunhoEditar: false });
      });
    } catch (error) {
      this.setState({ loadingRascunhoEditar: false });
      this.props.showNotification({
        level: 'error',
        message: `Falha ao remover ${fieldName}!`
      });
    }
  };

  editarProprietarioCidadao = async (proprietario, posicao) => {
    await this.editarListaIdentificadores(
      'proprietario',
      'proprietarios',
      this.props.declaracaoService.updateProprietarios
    )(proprietario, posicao);

    await this.sincronizarProprietarios();
  };

  editarAnuente = this.editarListaIdentificadores(
    'anuente',
    'anuentes',
    this.props.declaracaoService.updateAnuentes
  );

  deletarProprietarioCidadao = async posicao => {
    await this.deletarListaIdentificadores(
      'proprietario',
      'proprietarios',
      this.props.declaracaoService.deleteProprietarios
    )(posicao);

    await this.sincronizarProprietarios();
  };

  deletarVendedor = async posicao => {
    await this.deletarListaIdentificadores(
      'vendedor',
      'vendedores',
      this.props.declaracaoService.deleteVendedores
    )(posicao);

    await this.sincronizarProprietarios();
  };

  deletarAnuente = this.deletarListaIdentificadores(
    'anuente',
    'anuentes',
    this.props.declaracaoService.deleteAnuentes
  );

  onSetPrincipalCidadao = person => {
    const { id } = this.state;

    this.setState({ loadingRascunhoEditar: true });
    this.props.declaracaoService
      .definirPrincipal(id, person)
      .then(response =>
        this.setState(state => ({
          dadosIdentificacao: {
            ...state.dadosIdentificacao,
            proprietarios: response.data
          }
        }))
      )
      .finally(() => this.setState({ loadingRascunhoEditar: false }));
  };

  sincronizarProprietarios = async () => {
    if (
      !this.state.parametros?.utilizaFluxoAutonomiaCidadao &&
      !this.state.parametros?.utilizaItbiMaisFacil &&
      !this.state.dadosImoveis?.tipoItbi?.utilizaTramitacaoAutomatica
    ) {
      return;
    }

    try {
      const response = await this.props.declaracaoService.getProprietarios(
        this.state.id
      );
      const novosProprietarios = response.data;

      this.setState(prevState => ({
        dadosIdentificacao: {
          ...prevState.dadosIdentificacao,
          proprietarios: novosProprietarios
        }
      }));
    } catch (error) {
      console.warn('Falha ao sincronizar proprietários:', error);
    }
  };

  editarComprador = async (comprador, posicao) => {
    await this.editarListaIdentificadores(
      'comprador',
      'compradores',
      this.props.declaracaoService.updateCompradores
    )(comprador, posicao);

    await this.sincronizarProprietarios();
  };

  editarVendedor = (vendedor, posicao) => {
    return this.editarListaIdentificadores(
      'vendedor',
      'vendedores',
      this.props.declaracaoService.updateVendedores
    )(vendedor, posicao).then(() => {
      return this.sincronizarProprietarios();
    });
  };

  deletarComprador = async posicao => {
    await this.deletarListaIdentificadores(
      'comprador',
      'compradores',
      this.props.declaracaoService.deleteCompradores
    )(posicao);

    await this.sincronizarProprietarios();
  };

  removerProprietarioCorrespondente = async comprador => {
    try {
      const { proprietarios } = this.state.dadosIdentificacao;
      const proprietarioCorrespondente = proprietarios.find(
        prop => prop.cpfCnpj === comprador.cpfCnpj
      );

      if (proprietarioCorrespondente) {
        await this.props.declaracaoService.deleteProprietarios(
          this.state.id,
          proprietarioCorrespondente.id
        );
      }
    } catch (error) {}
  };

  onViewPessoa = pessoa => {
    this.setState({
      pessoaQuickView: pessoa
    });
  };

  onCloseQuickViewPessoa = () => {
    this.setState({
      pessoaQuickView: undefined
    });
  };

  onChangeInputValue = event => {
    const target = event?.target || event?.currentTarget || {};
    const fieldName = target.name;

    if (!fieldName) {
      return;
    }

    const normalizedFieldName = fieldName.replace(
      /^requerente([A-Z])/,
      (_, letter) => {
        return letter.toLowerCase();
      }
    );

    const value =
      typeof target.value === 'undefined' ? event?.value ?? '' : target.value;
    const newValue = ['cep', 'telefone', 'cpfCnpj'].includes(
      normalizedFieldName
    )
      ? String(value).replace(/\D/g, '')
      : value;

    this.setState(prevState => ({
      dadosImoveis: {
        ...prevState.dadosImoveis,
        requerente: {
          ...prevState.dadosImoveis.requerente,
          [normalizedFieldName]: newValue
        },
        error: {
          ...prevState.dadosImoveis.error,
          requerente: {
            ...prevState.dadosImoveis.error.requerente,
            [normalizedFieldName]: false,
            [`${normalizedFieldName}Length`]: false,
            emailInvalid: false
          }
        }
      }
    }));
  };

  onChangeInputCpfCnpj = event => {
    const value = event?.target?.value ?? event?.currentTarget?.value ?? '';
    const { showNotification, userService } = this.props;

    const cpfCnpj = StringUtils.somenteNumerosELetras(value);

    this.setState(prevState => ({
      dadosImoveis: {
        ...prevState.dadosImoveis,
        requerente: {
          ...prevState.dadosImoveis.requerente,
          cpfCnpj
        }
      }
    }));

    if (validateCpfCnpj(cpfCnpj)) {
      this.setState({ loadingRequerente: true });
      userService
        .getUsuarioTributosByCpf(cpfCnpj)
        .then(response => {
          if (response.data) {
            const { id, nome, telefone, email, tipoPessoa } = response.data;

            this.setState(prevState => ({
              dadosImoveis: {
                ...prevState.dadosImoveis,
                requerente: {
                  ...prevState.dadosImoveis.requerente,
                  id,
                  nome,
                  telefone,
                  email,
                  tipoPessoa
                }
              }
            }));
          } else {
            this.setState(prevState => ({
              dadosImoveis: {
                ...prevState.dadosImoveis,
                requerente: {
                  ...prevState.dadosImoveis.requerente,
                  id: undefined
                }
              }
            }));
          }
        })
        .catch(() => {
          showNotification({
            level: 'error',
            message: 'Erro ao carregar usuário por CPF/CNPJ'
          });
        })
        .finally(() => {
          this.setState(prevState => ({
            dadosImoveis: {
              ...prevState.dadosImoveis,
              error: {
                ...prevState.dadosImoveis.error,
                requerente: {
                  ...prevState.dadosImoveis.error.requerente,
                  cpfCnpj: false
                }
              }
            },
            loadingRequerente: false
          }));
        });
    } else {
      this.setState(prevState => ({
        dadosImoveis: {
          ...prevState.dadosImoveis,
          error: {
            ...prevState.dadosImoveis.error,
            requerente: {
              ...prevState.dadosImoveis.error.requerente,
              cpfCnpj: true
            }
          }
        }
      }));
    }
  };

  verificarInadimplencia = cadastroParaItbi => {
    const { tipoCadastro, cadastro } = cadastroParaItbi;
    const bloqueiaItbiCadInadimplente = this.state.parametros
      ?.bloqueiaItbiCadInadimplente;
    const { cadastroGeralService } = this.props;
    this.setState({ loadingInadimplencia: true });
    cadastroGeralService
      .isInadimplente(tipoCadastro, cadastro)
      .then(response => {
        this.setState({
          loadingInadimplencia: false,
          isCadastroInadimplente: response.data
        });

        if (response.data && bloqueiaItbiCadInadimplente) {
          this.avisarCadastroBloqueado(() =>
            Alert.warning({
              title: 'Atenção',
              text:
                'Não é possível realizar o pedido para este cadastro, pois ele se encontra irregular. Entre em contato com o município para regularização.'
            })
          );
        }
      })
      .catch(err => {
        this.setState({ loadingInadimplencia: false });
        this.tratarErroValidacaoCadastro(err);
      });
  };

  /**
   * O Tributos responde 400 "Cadastro não encontrado" para cadastro com exclusão
   * lógica, que a réplica do ITBI ainda devolve. Sem limpar, o número digitado
   * passaria na validação do passo 1 (cadastro > 0). Limpando, o resultado é o
   * mesmo do servidor, onde a pesquisa nem lista o cadastro excluído.
   */
  tratarErroValidacaoCadastro = async err => {
    if (err?.response?.status !== 400) {
      Alert.error('Não foi possivel validar situação do cadastro', err);
      return;
    }
    this.avisarCadastroBloqueado(() => Alert.error({ title: 'Atenção' }, err));
  };

  /**
   * Enter e saída do campo disparam a mesma busca (o foco do botão OK do alerta
   * também tira o foco do campo). Enquanto um aviso está aberto, os seguintes
   * são ignorados; ao clicar em OK o cadastro é limpo uma única vez.
   */
  avisarCadastroBloqueado = async mostrarAlerta => {
    if (this.avisoCadastroAberto) {
      return;
    }
    this.avisoCadastroAberto = true;
    try {
      await mostrarAlerta();
    } finally {
      this.avisoCadastroAberto = false;
    }
    this.limparCadastroSelecionado();
  };

  limparCadastroSelecionado = () => {
    const { isServidor } = this.props;
    const vendedoresVemDoCadastro =
      isServidor || this.state.parametros?.utilizaFluxoAutonomiaCidadao;

    this.handleClearCadastroImobiliario();
    this.limparEnglobamento();
    this.setState(
      this.newStateDadosImoveis({ temValorReferenciaItbiMaisFacil: false })
    );
    this.setState(state => ({
      isCadastroInadimplente: false,
      debitosEmAberto: undefined,
      avisoDebitosVisible: false,
      avisoDebitosExpandido: false,
      itbiMaisFacil: {
        ...state.itbiMaisFacil,
        visible: false,
        dados: null,
        aceitou: null
      },
      ...(vendedoresVemDoCadastro && {
        dadosIdentificacao: { ...state.dadosIdentificacao, vendedores: [] }
      })
    }));
  };

  verificarDebitosEmAberto = async cadastroParaItbi => {
    if (this.state.parametros === undefined) {
      await this.parametrosPromise;
    }

    if (!this.state.parametros?.avisaDebitoAbertoItbi) {
      return;
    }

    const { tipoCadastro, cadastro } = cadastroParaItbi;
    const chaveDebitos = `${tipoCadastro}-${cadastro}`;

    if (this.chaveDebitosConsultada === chaveDebitos) {
      return;
    }
    this.chaveDebitosConsultada = chaveDebitos;

    const { debitoService } = this.props;
    this.setState({
      loadingDebitos: true,
      avisoDebitosVisible: false,
      avisoDebitosExpandido: false,
      debitosEmAberto: undefined
    });
    debitoService
      .getDebitosEmAberto(tipoCadastro, cadastro)
      .then(response => {
        const debitosEmAberto = response.data;
        const possuiDebitos = (debitosEmAberto?.debitos?.length ?? 0) > 0;

        this.setState({
          loadingDebitos: false,
          debitosEmAberto,
          avisoDebitosVisible: possuiDebitos,
          avisoDebitosExpandido: false
        });

        if (possuiDebitos) {
          Alert.warning({
            title: 'Atenção',
            text: 'Este cadastro possui débitos em aberto.'
          });
        }
      })
      .catch(err => {
        this.chaveDebitosConsultada = null;
        this.setState({ loadingDebitos: false });
        Alert.error(
          { title: 'Não foi possível verificar débitos em aberto do cadastro' },
          err
        );
      });
  };

  toggleDebitosExpandido = () => {
    this.setState(prevState => ({
      avisoDebitosExpandido: !prevState.avisoDebitosExpandido
    }));
  };

  //#endregion identificacao
  /**
   * Campos de localização exibidos no fluxo de declaração, conforme a
   * parametrização de Tributos > Configurações > Inscrição Cadastral.
   */
  carregarCamposLocalizacao = () =>
    InscricaoCadastralUtils.carregarCamposLocalizacao().then(
      camposLocalizacao => this.setState({ camposLocalizacao })
    );

  render() {
    const {
      listRequerentes,
      user,
      isServidor,
      permiteItbiRural = false
    } = this.props;
    const {
      dadosImoveis,
      dadosIdentificacao,
      loadingRascunhoEditar,
      pessoaQuickView,
      step1,
      step2,
      step3,
      vinculos,
      parametros,
      valorRecursoProprio,
      loadingRequerente,
      loadingInadimplencia,
      itbiMaisFacil,
      debitosEmAberto,
      avisoDebitosVisible,
      avisoDebitosExpandido,
      loadingDebitos
    } = this.state;
    const habilitaGestaoProprietario =
      parametros?.utilizaFluxoAutonomiaCidadao ||
      parametros?.utilizaItbiMaisFacil ||
      dadosImoveis.tipoItbi?.utilizaTramitacaoAutomatica;

    return (
      <React.Fragment>
        {itbiMaisFacil.visible && (
          <ItbiMaisFacilModal
            dados={itbiMaisFacil.dados}
            isFinanciado={itbiMaisFacil.isFinanciado}
            textoItbiMaisFacil={this.state.parametros?.textoItbiMaisFacil}
            onAccept={this.onAcceptItbiMaisFacil}
            onDecline={this.onDeclineItbiMaisFacil}
            onClose={this.onCloseItbiMaisFacil}
          />
        )}
        <Loading
          loading={
            step1.submitting ||
            loadingRascunhoEditar ||
            step3.submitting ||
            loadingRequerente ||
            loadingInadimplencia
          }
        />
        <PessoasQuickView
          pessoa={pessoaQuickView}
          onClose={this.onCloseQuickViewPessoa}
        />
        <Wizard
          beforeChange={this.onBeforeChange}
          allowInvalidChange={false}
          onFinish={this.finalizar}
          showExitButton={false}
        >
          <Wizard.Step
            stepId="1"
            label="Imóvel"
            icon="far fa-building"
            valid={step1.valid}
            errorMessage={step1.errorMessage}
            showExitButton={false}
            showFinishButton={false}
            submittingNextButton={step1.submitting}
          >
            <Imovel
              camposLocalizacao={this.state.camposLocalizacao}
              dadosImoveis={dadosImoveis}
              handleChangeFieldCurrency={this.handleChangeFieldCurrency}
              handleChangeValoresItbi={this.onChangeValoresItbi}
              handleChangeSelectTipoItbi={this.handleChangeSelectTipoItbi}
              handleChangeSelectRequerente={this.handleChangeSelectRequerente}
              handleChangeCadastroImobiliario={
                this.handleChangeCadastroImobiliario
              }
              handleClearCadastroImobiliario={
                this.handleClearCadastroImobiliario
              }
              handleKeyDownCadastroImobiliario={
                this.handleKeyDownCadastroImobiliario
              }
              handleBlurCadastroImobiliario={this.handleBlurCadastroImobiliario}
              handleChangeFieldDocument={this.handleChangeFieldDocument}
              handleChangeField={this.handleChangeField}
              errorMessages={errorMessages}
              handleChangeUploadFile={this.handleChangeUploadFile}
              handleRemoveFile={this.handleRemoveFile}
              isServidor={isServidor}
              onChangeInputValue={this.onChangeInputValue}
              onChangeInputCpfCnpj={this.onChangeInputCpfCnpj}
              listRequerentes={listRequerentes}
              permiteItbiRural={permiteItbiRural}
              permiteCriacaoCadastroRuralItbi={
                parametros?.permiteCriacaoCadastroRuralItbi
              }
              permiteBuscaPorInscricaoCadastral={
                parametros?.buscaImobiliarioPorInscricao
              }
              handleChangeCadastroRural={this.handleChangeCadastroRural}
              handleBlurCadastroRural={this.handleBlurCadastroRural}
              handleSelectCadastroPesquisa={this.handleSelectCadastroPesquisa}
              valorRecursoProprio={valorRecursoProprio}
              utilizaFluxoAutonomiaCidadao={
                parametros?.utilizaFluxoAutonomiaCidadao
              }
              disabled={
                !isServidor &&
                dadosImoveis.retificadora &&
                parametros?.utilizaFluxoAutonomiaCidadao
              }
            />
            <EnglobadosList
              englobados={dadosImoveis.englobados}
              cadastroSelecionado={dadosImoveis.cadastroSelecionadoEnglobamento}
              cadastroPai={dadosImoveis.cadastroPaiEnglobamento}
            />
            {avisoDebitosVisible && (
              <Info type="warning" beaty>
                Este cadastro possui débitos em aberto.{' '}
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={this.toggleDebitosExpandido}
                >
                  {avisoDebitosExpandido ? 'Ocultar débitos' : 'Ver débitos'}
                </a>
              </Info>
            )}
            {avisoDebitosExpandido && (
              <DebitosEmAbertoTable
                debitosEmAberto={debitosEmAberto}
                loading={loadingDebitos}
              />
            )}
          </Wizard.Step>
          <Wizard.Step
            stepId="2"
            label="Identificação"
            icon="far fa-users"
            valid={step2.valid}
            errorMessage={step2.errorMessage}
            showExitButton={false}
            showFinishButton={false}
          >
            <Identificacao
              dadosIdentificacao={dadosIdentificacao}
              adicionarComprador={this.adicionarComprador}
              editarComprador={this.editarComprador}
              deletarComprador={this.deletarComprador}
              adicionarVendedor={this.adicionarVendedor}
              editarVendedor={this.editarVendedor}
              deletarVendedor={this.deletarVendedor}
              adicionarAnuente={this.adicionarAnuente}
              editarAnuente={this.editarAnuente}
              deletarAnuente={this.deletarAnuente}
              adicionarProprietarioCidadao={
                habilitaGestaoProprietario
                  ? this.adicionarProprietarioCidadao
                  : undefined
              }
              editarProprietarioCidadao={
                habilitaGestaoProprietario
                  ? this.editarProprietarioCidadao
                  : undefined
              }
              deletarProprietarioCidadao={
                habilitaGestaoProprietario
                  ? this.deletarProprietarioCidadao
                  : undefined
              }
              onSetPrincipalCidadao={
                habilitaGestaoProprietario
                  ? this.onSetPrincipalCidadao
                  : undefined
              }
              permiteEditarProprietario={
                habilitaGestaoProprietario
                  ? parametros?.permiteEditarProprietario
                  : undefined
              }
              permiteDeletarProprietario={
                habilitaGestaoProprietario
                  ? parametros?.permiteDeletarProprietario
                  : undefined
              }
              validaRgComprador={parametros?.validaRgComprador ?? true}
              user={user}
              requerente={dadosImoveis.requerente}
              anuencia={dadosImoveis.tipoItbi && dadosImoveis.tipoItbi.anuencia}
              vinculos={vinculos}
              onViewPessoa={this.onViewPessoa}
              isServidor={isServidor}
              onChangePrincipal={this.onSetPrincipalCidadao}
              utilizaFluxoAutonomiaCidadao={
                parametros?.utilizaFluxoAutonomiaCidadao
              }
              utilizaItbiMaisFacil={parametros?.utilizaItbiMaisFacil}
              utilizaTramitacaoAutomatica={
                dadosImoveis.tipoItbi?.utilizaTramitacaoAutomatica
              }
              disabled={
                !isServidor &&
                dadosImoveis.retificadora &&
                parametros?.utilizaFluxoAutonomiaCidadao
              }
            />
          </Wizard.Step>
          <Wizard.Step
            stepId="3"
            label="Resumo"
            icon="far fa-file-alt"
            valid={step3.valid}
            errorMessage={step3.errorMessage}
            showExitButton={false}
            submittingFinishButton={step3.submitting}
          >
            <Resumo
              compradores={dadosIdentificacao.compradores}
              vendedores={dadosIdentificacao.vendedores}
              anuentes={dadosIdentificacao.anuentes}
              proprietarios={dadosIdentificacao.proprietarios}
              dadosImovel={dadosImoveis}
              onViewPessoa={this.onViewPessoa}
              valorRecursoProprio={valorRecursoProprio}
              isServidor={isServidor}
              utilizaFluxoAutonomiaCidadao={
                parametros?.utilizaFluxoAutonomiaCidadao
              }
              camposLocalizacao={this.state.camposLocalizacao}
            />
          </Wizard.Step>
        </Wizard>
      </React.Fragment>
    );
  }
}

const WithServiceComponent = withService({
  imobiliarioService: ImobiliarioService,
  parametroGeralService: ParametroGeralService,
  parametroService: ParametroService,
  declaracaoService: DeclaracaoService,
  uploadService: UploadService,
  proprietarioService: ProprietarioService,
  userService: UserService,
  cadastroRuralService: CadastroRuralService,
  cadastroGeralService: CadastroGeralService,
  debitoService: DebitoService
})(DeclaracaoItbiForm);

export { WithServiceComponent as default, DeclaracaoItbiForm };
